'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'garage';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'e009';
var svgPathData = 'M368,416H272a16,16,0,0,0,0,32h96a16,16,0,0,0,0-32ZM610.59,118.33,338.59,3.75a48,48,0,0,0-37.18,0l-272,114.58A47.84,47.84,0,0,0,0,162.53V504a8,8,0,0,0,8,8H24a8,8,0,0,0,8-8V162.53a16,16,0,0,1,9.81-14.79l272-114.6a15.75,15.75,0,0,1,12.38,0l272,114.6A15.91,15.91,0,0,1,608,162.53V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V162.53A47.84,47.84,0,0,0,610.59,118.33ZM512,192H128a32,32,0,0,0-32,32V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V352H512V504a8,8,0,0,0,8,8h16a8,8,0,0,0,8-8V224A32,32,0,0,0,512,192Zm0,128H128V224H512Z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faGarage = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;